import { render, staticRenderFns } from "./PFDeRegistration.vue?vue&type=template&id=15b9058e"
import script from "./PFDeRegistration.vue?vue&type=script&lang=js"
export * from "./PFDeRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports